import React from 'react';
import './index.less';

interface EmptyUsersProps {
  emptyText?: string;
  showImage?: boolean;
}

const EmptyUsers: React.FC<EmptyUsersProps> = ({
  emptyText = '暂无数据',
  showImage = true
}) => {
  return (
    <div className="empty-users">
      {showImage && (
        <img
          alt="empty"
          src={require("../../pages/invite-new-guest/assets/empty.svg")}
          className="empty-img"
        />
      )}
      <div className="empty-text">{emptyText}</div>
    </div>
  );
};

export default EmptyUsers;
